import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-modal-dynamic',
  templateUrl: './modal-dynamic.component.html',
  styleUrls: ['./modal-dynamic.component.scss'],
})
export class ModalDynamicComponent {
  @Input() title: string;
  @Input() message: string;
  @Input() icon: string = 'assets/img/icono-modal.png';
  @Input() actionLabel: string = 'Entendido';
  @Input() show: boolean = false;
  @Input() closeButton: boolean = true;

  @Output() primaryAction = new EventEmitter<any>();
  @Output() close = new EventEmitter<any>();

  onPrimaryAction() {
    this.primaryAction.emit();
  }

  onClose() {
    this.close.emit();
  }
}
